import axios from "axios";
import { attachMockInterceptor } from "./setupMockInterceptors";

const PublicAdminPanelInstance = axios.create({
  baseURL: process.env.REACT_APP_ADMIN_PANEL_BACKEND_BASE_URL,
});

attachMockInterceptor(PublicAdminPanelInstance);

export default PublicAdminPanelInstance;
